import { defineComponent as P, ref as y, onMounted as q, computed as a, inject as W, provide as ue, watchEffect as pe, h as c, nextTick as de, onUnmounted as fe } from "vue";
import { FocusTrap as $ } from "./index346.js";
import { useDocumentOverflowLockedEffect as ve } from "./index347.js";
import { useEventListener as ce } from "./index348.js";
import { useId as b } from "./index327.js";
import { useInert as G } from "./index349.js";
import { useOutsideClick as ge } from "./index328.js";
import { useRootContainers as me } from "./index350.js";
import { useOpenClosed as De, State as F } from "./index333.js";
import { ForcePortalRoot as N } from "./index351.js";
import { useStackProvider as ye, StackMessage as K } from "./index352.js";
import { Keys as he } from "./index334.js";
import { dom as L } from "./index339.js";
import { match as Q } from "./index342.js";
import { getOwnerDocument as Se } from "./index343.js";
import { render as O, Features as V } from "./index345.js";
import { useDescriptions as $e } from "./index353.js";
import { useNestedPortals as Pe, Portal as X, PortalGroup as be } from "./index354.js";
var Oe = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Oe || {});
let M = Symbol("DialogContext");
function k(e) {
  let i = W(M, null);
  if (i === null) {
    let o = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(o, k), o;
  }
  return i;
}
let B = "DC8F892D-2EBD-447C-A4C8-A03058436FF4", Ye = P({ name: "Dialog", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, open: { type: [Boolean, String], default: B }, initialFocus: { type: Object, default: null }, id: { type: String, default: null }, role: { type: String, default: "dialog" } }, emits: { close: (e) => !0 }, setup(e, { emit: i, attrs: o, slots: p, expose: u }) {
  var s, r;
  let n = (s = e.id) != null ? s : `headlessui-dialog-${b()}`, g = y(!1);
  q(() => {
    g.value = !0;
  });
  let D = !1, U = a(() => e.role === "dialog" || e.role === "alertdialog" ? e.role : (D || (D = !0, console.warn(`Invalid role [${U}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog")), x = y(0), h = De(), w = a(() => e.open === B && h !== null ? (h.value & F.Open) === F.Open : e.open), m = y(null), C = a(() => Se(m));
  if (u({ el: m, $el: m }), !(e.open !== B || h !== null)) throw new Error("You forgot to provide an `open` prop to the `Dialog`.");
  if (typeof w.value != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${w.value === B ? void 0 : e.open}`);
  let v = a(() => g.value && w.value ? 0 : 1), R = a(() => v.value === 0), T = a(() => x.value > 1), H = W(M, null) !== null, [Z, _] = Pe(), { resolveContainers: j, mainTreeNodeRef: Y, MainTreeNode: J } = me({ portals: Z, defaultContainers: [a(() => {
    var l;
    return (l = S.panelRef.value) != null ? l : m.value;
  })] }), ee = a(() => T.value ? "parent" : "leaf"), z = a(() => h !== null ? (h.value & F.Closing) === F.Closing : !1), le = a(() => H || z.value ? !1 : R.value), te = a(() => {
    var l, t, d;
    return (d = Array.from((t = (l = C.value) == null ? void 0 : l.querySelectorAll("body > *")) != null ? t : []).find((f) => f.id === "headlessui-portal-root" ? !1 : f.contains(L(Y)) && f instanceof HTMLElement)) != null ? d : null;
  });
  G(te, le);
  let ae = a(() => T.value ? !0 : R.value), oe = a(() => {
    var l, t, d;
    return (d = Array.from((t = (l = C.value) == null ? void 0 : l.querySelectorAll("[data-headlessui-portal]")) != null ? t : []).find((f) => f.contains(L(Y)) && f instanceof HTMLElement)) != null ? d : null;
  });
  G(oe, ae), ye({ type: "Dialog", enabled: a(() => v.value === 0), element: m, onUpdate: (l, t) => {
    if (t === "Dialog") return Q(l, { [K.Add]: () => x.value += 1, [K.Remove]: () => x.value -= 1 });
  } });
  let re = $e({ name: "DialogDescription", slot: a(() => ({ open: w.value })) }), E = y(null), S = { titleId: E, panelRef: y(null), dialogState: v, setTitleId(l) {
    E.value !== l && (E.value = l);
  }, close() {
    i("close", !1);
  } };
  ue(M, S);
  let ne = a(() => !(!R.value || T.value));
  ge(j, (l, t) => {
    l.preventDefault(), S.close(), de(() => t?.focus());
  }, ne);
  let ie = a(() => !(T.value || v.value !== 0));
  ce((r = C.value) == null ? void 0 : r.defaultView, "keydown", (l) => {
    ie.value && (l.defaultPrevented || l.key === he.Escape && (l.preventDefault(), l.stopPropagation(), S.close()));
  });
  let se = a(() => !(z.value || v.value !== 0 || H));
  return ve(C, se, (l) => {
    var t;
    return { containers: [...(t = l.containers) != null ? t : [], j] };
  }), pe((l) => {
    if (v.value !== 0) return;
    let t = L(m);
    if (!t) return;
    let d = new ResizeObserver((f) => {
      for (let I of f) {
        let A = I.target.getBoundingClientRect();
        A.x === 0 && A.y === 0 && A.width === 0 && A.height === 0 && S.close();
      }
    });
    d.observe(t), l(() => d.disconnect());
  }), () => {
    let { open: l, initialFocus: t, ...d } = e, f = { ...o, ref: m, id: n, role: U.value, "aria-modal": v.value === 0 ? !0 : void 0, "aria-labelledby": E.value, "aria-describedby": re.value }, I = { open: v.value === 0 };
    return c(N, { force: !0 }, () => [c(X, () => c(be, { target: m.value }, () => c(N, { force: !1 }, () => c($, { initialFocus: t, containers: j, features: R.value ? Q(ee.value, { parent: $.features.RestoreFocus, leaf: $.features.All & ~$.features.FocusLock }) : $.features.None }, () => c(_, {}, () => O({ ourProps: f, theirProps: { ...d, ...o }, slot: I, attrs: o, slots: p, visible: v.value === 0, features: V.RenderStrategy | V.Static, name: "Dialog" })))))), c(J)]);
  };
} }), ze = P({ name: "DialogOverlay", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(e, { attrs: i, slots: o }) {
  var p;
  let u = (p = e.id) != null ? p : `headlessui-dialog-overlay-${b()}`, s = k("DialogOverlay");
  function r(n) {
    n.target === n.currentTarget && (n.preventDefault(), n.stopPropagation(), s.close());
  }
  return () => {
    let { ...n } = e;
    return O({ ourProps: { id: u, "aria-hidden": !0, onClick: r }, theirProps: n, slot: { open: s.dialogState.value === 0 }, attrs: i, slots: o, name: "DialogOverlay" });
  };
} });
P({ name: "DialogBackdrop", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { attrs: i, slots: o, expose: p }) {
  var u;
  let s = (u = e.id) != null ? u : `headlessui-dialog-backdrop-${b()}`, r = k("DialogBackdrop"), n = y(null);
  return p({ el: n, $el: n }), q(() => {
    if (r.panelRef.value === null) throw new Error("A <DialogBackdrop /> component is being used, but a <DialogPanel /> component is missing.");
  }), () => {
    let { ...g } = e, D = { id: s, ref: n, "aria-hidden": !0 };
    return c(N, { force: !0 }, () => c(X, () => O({ ourProps: D, theirProps: { ...i, ...g }, slot: { open: r.dialogState.value === 0 }, attrs: i, slots: o, name: "DialogBackdrop" })));
  };
} });
let Ge = P({ name: "DialogPanel", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(e, { attrs: i, slots: o, expose: p }) {
  var u;
  let s = (u = e.id) != null ? u : `headlessui-dialog-panel-${b()}`, r = k("DialogPanel");
  p({ el: r.panelRef, $el: r.panelRef });
  function n(g) {
    g.stopPropagation();
  }
  return () => {
    let { ...g } = e, D = { id: s, ref: r.panelRef, onClick: n };
    return O({ ourProps: D, theirProps: g, slot: { open: r.dialogState.value === 0 }, attrs: i, slots: o, name: "DialogPanel" });
  };
} });
P({ name: "DialogTitle", props: { as: { type: [Object, String], default: "h2" }, id: { type: String, default: null } }, setup(e, { attrs: i, slots: o }) {
  var p;
  let u = (p = e.id) != null ? p : `headlessui-dialog-title-${b()}`, s = k("DialogTitle");
  return q(() => {
    s.setTitleId(u), fe(() => s.setTitleId(null));
  }), () => {
    let { ...r } = e;
    return O({ ourProps: { id: u }, theirProps: r, slot: { open: s.dialogState.value === 0 }, attrs: i, slots: o, name: "DialogTitle" });
  };
} });
export {
  Ye as Dialog,
  ze as DialogOverlay,
  Ge as DialogPanel
};
